
import React, { useEffect, useState, useRef } from 'react';

import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import PaginationTable from '../../pagination/Pagination4';

const MonthC = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

const Stock_data = async (params) => {

    const response = await fetch(`${process.env.REACT_APP_URL_SIDE}/Ro/truck_ro_Received_Month_Wise`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(params),
    });
    if (!response.ok) {
        throw new Error('Failed to fetch data');
    }
    return response.json();
};

const Truck_ro_recive_m_y_rep = ({ month, year, fps_id, dist_code, heading }) => {

    const [reportData, setReportData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [tabHeading, setTabHeading] = useState(null);
    const [renderContentt, setRenderContentt] = useState(null);
    const detailsRRef = useRef(null);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(50);

    useEffect(() => {
        const getData = async () => {
            try {
                const response_data = await Stock_data({ month, year, fps_id, dist_code, heading });
                //console.log(response_data)
                setTabHeading(response_data.heading);
                if (response_data.data.length > 0) {
                    setReportData(response_data.data);

                } else {
                    setReportData([]);
                }
            } catch (error) {
                setError(error);
            } finally {
                setLoading(false);
            }
        };
        getData();
    }, [month, year, fps_id, dist_code, heading]);


    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (value) => {
        setRowsPerPage(value === 'all' ? reportData.length : parseInt(value, 10));
        setPage(0); // Reset page to 0 when changing rows per page
    };

    useEffect(() => {
        if (!loading && !error && reportData.length > 0 && detailsRRef.current) {
            detailsRRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
    }, [reportData]);

    if (loading) {

        return (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <Box sx={{ display: 'flex' }}>
                    <CircularProgress />
                </Box>
            </div>
        );
    }
    if (error) {
        console.log(error);
        return <div className="mainhead" align="center">Internal Error</div>;
    }
    if (reportData.length === 0) {
        return <div className="mainhead" align="center">No data found</div>;
    }


    const paginatedData = rowsPerPage === 'all'
        ? reportData
        : reportData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

    return (
        <>
            <table align="center" width="85%" border={1} id="">
                <thead>
                    <tr className="tableheader">
                        <th colSpan={8 + reportData[0].commoditylist.length}>{tabHeading}</th>
                    </tr>
                    <tr className="tableheader">
                        <th rowSpan={2}>Sl.No</th>
                        <th rowSpan={2}>District</th>

                        <th rowSpan={2}>Office</th>
                        <th rowSpan={2}>Fps ID</th>
                        <th rowSpan={2}>Truck Chit ID</th>
                        <th rowSpan={2}>Allocation<br />Order No</th>
                        <th rowSpan={2}>Alloted<br />Month/Year</th>

                        <th colSpan={reportData[0].commoditylist.length} >
                            Commodity
                        </th>
                        <th rowSpan={2}>Recived  Date</th>
                    </tr>
                    <tr className="tableheader">
                        {reportData[0].commoditylist.map((item, index) => (
                            <th key={index}>{item.comm_name_en}</th>
                        ))}

                    </tr>

                </thead>
                <tbody>
                    {paginatedData.map((item, index) => (
                        <tr key={item.dist_code}>
                            <td style={{ textAlign: 'center' }}>{rowsPerPage === 'all' ? index + 1 : index + 1 + page * rowsPerPage}</td> {/* Adjusted Sl.No */}

                            <td style={{ textAlign: 'left' }}>
                                {item.dist_name_en}

                            </td>
                            <td style={{ textAlign: 'right', whiteSpace: 'nowrap' }}>{item.afso_name_en}</td>
                            <td style={{ textAlign: 'right' }}>{item.fps_id}</td>
                            <td style={{ textAlign: 'right' }}>{item.truckchitno}</td>
                            <td style={{ textAlign: 'right', whiteSpace: 'nowrap' }}>{item.allocation_orderno}</td>
                            <td style={{ textAlign: 'right', whiteSpace: 'nowrap' }}>{MonthC[item.alot_month - 1]} / {item.alot_year}</td>


                            {item.commoditylist.map((item1, index) => (
                                <td style={{ textAlign: 'right' }} key={index}>{item1.allot_qty.toFixed(3)}</td>
                            ))}
                            <td style={{ textAlign: 'right', whiteSpace: 'nowrap' }}>{item.rec_date}</td>

                        </tr>
                    ))}
                </tbody>

            </table>
            <br /><br />

            <div width="75%" style={{ display: 'flex', justifyContent: 'right', alignItems: 'start', width: '95%' }}>
                <PaginationTable
                    count={reportData.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                /></div>
            <br></br>
            <div id="detailsERR" ref={detailsRRef}>{renderContentt}</div>

        </>
    );
};
export default Truck_ro_recive_m_y_rep;
